var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("CATEGORY")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'FirstLesson' }}},[_vm._v("First Lesson")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'SecondLesson' }}},[_vm._v("Second Lesson")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bccf7b1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlightSchoolSideNav.vue
// module id = null
// module chunks = 